import { useEffect } from "react";
import { consumePendingManufacturingPartUseId } from "@/lib/workspaceModeNavigation";

/** When Models opens from order mapping, land on that part use. */
export function usePendingManufacturingPartUse(apply: (useId: string) => void): void {
  useEffect(() => {
    const useId = consumePendingManufacturingPartUseId();
    if (useId) apply(useId);
    // The pending id is consumed once, when Models mounts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
